import { useState } from 'react';
import './Search.css';
import SearchSuggestionList from './SearchSuggestionList';
import API_SERVICE from '../../utils/apiService';

function Search(props) {
  const { searchText, setSearchText, onSearch } = props;

  const [suggestions, setSuggestions] = useState([]);

  const handleChange = (event) => {
    const text = event.target.value;
    setSearchText(text);
    fetchSuggestions(text);
  }

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault(); // prevent adding a new line
      onSearch(searchText);
      setSearchText("");
      setSuggestions([]);
    }
  }

  const fetchSuggestions = async (text) => {
    if (!text) {
      setSuggestions([]);
      return;
    } else {
      const data = await API_SERVICE.fetchSuggestions(text);
      setSuggestions(data.suggestions);
    }
  }

  return (
    <div id="search">
      <div className="search__box">
        {/* wish i could get a search icon right before the initial text cursor */}
        <textarea
          placeholder="search spanish verb"
          value={searchText}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
        />
      </div>
      <SearchSuggestionList
        suggestions={suggestions}
      />
    </div>
  );
}

export default Search;
